import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import VisorPDF from "@Utilitarios/VisorPDF/VisorPDF";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import "./MRegistroVentaTienda.css";

function MRegistroVentaTienda({
  origenComponente,
  registro = {},
  parametros,
  datosComplementarios,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
  modo, //solo disponible para agregar persona
}) {
  const { ecv_u, cv_u, esComputadora } = useContext(Contexto);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    form: null,
    datosForm: {},
    respuestaActualizacion: {},
    d_datosForm_historico: {},
    totalEntrega: 0,
    d_sinComprobante: false,
    d_pdf: "",
    d_exitoRegistrandoVenta: false,
  });
  const [actualizaDatosTabla, setactualizaDatosTabla] = useState(null);

  useEffect(() => {
    console.log(origenComponente, registro, parametros, tipoEvento);
    console.log("primera validacion: ", registro?.codigo ?? "");
    const formularioAPI = _api_.f_FormularioComprobantesVT({
      parametros: {
        tipoComprobante: parametros?.tipoComprobante,
      },
      timeout: 5000,
    });
    formularioAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC.contenido?.datos);
      if (!dPC.error) {
        _f_.asignar(ev_u, { form: dPC.contenido.form });
      }
    });
    _f_.asignar(ev_u, { totalEntrega: parametros?.totalEntrega });
  }, []);

  const datosPersonaApi = (variables) => {
    // console.log(variables);
    if (parametros?.tipoComprobante == "BOLETA") {
      if (variables.nroDoc.length == 8 && variables.tipoDocumento == "1") {
        const datosAPI_DNI_RUC = _api_.f_obtenerPersonaDNI({
          parametros: {
            numeroDNI: variables.nroDoc,
          },
          timeout: 5000,
        });

        datosAPI_DNI_RUC.respuesta.then((dPC) => {
          _f_.asignar(ecv_u, dPC, true, origenComponente);
          console.log(dPC);
          if (!dPC.error) {
            let respuesta = dPC.contenido;
            let nombrePersona =
              respuesta.persona.nombre +
              " " +
              respuesta.persona.apellido_paterno +
              " " +
              respuesta.persona.apellido_materno;
            actualizaDatosTabla("nombre", nombrePersona);
          }
        });
      } else if (variables.tipoDocumento == "6" && variables.nroDoc.length == 11) {
        const datosAPI_DNI_RUC = _api_.f_obtenerEmpresaRUC({
          parametros: {
            numero_documento: variables.nroDoc,
          },
          timeout: 5000,
        });

        datosAPI_DNI_RUC.respuesta.then((dPC) => {
          _f_.asignar(ecv_u, dPC, true, origenComponente);
          console.log(dPC);
          if (!dPC.error) {
            let respuesta = dPC.contenido;
            let nombreEmpresa = respuesta?.empresa?.nombre;
            actualizaDatosTabla("nombre", nombreEmpresa);
          }
        });
      }
    } else if (parametros?.tipoComprobante == "FACTURA") {
      if (variables.nroDoc.length == 11) {
        const datosAPI_DNI_RUC = _api_.f_obtenerEmpresaRUC({
          parametros: {
            numero_documento: variables.nroDoc,
          },
          timeout: 5000,
        });

        datosAPI_DNI_RUC.respuesta.then((dPC) => {
          _f_.asignar(ecv_u, dPC, true, origenComponente);
          console.log(dPC);
          if (!dPC.error) {
            let respuesta = dPC.contenido;
            let nombreEmpresa = respuesta?.empresa?.nombre;
            actualizaDatosTabla("nombre", nombreEmpresa);
          }
        });
      }
    }
  };

  const cambioTipoDocumento = (variables, variablesAnterior) => {
    if (variables?.tipoDocumento !== variablesAnterior?.tipoDocumento) {
      actualizaDatosTabla("nroDoc", "");
      actualizaDatosTabla("nombre", "");
    }
  };

  const habilitadoEfectivo = (habilitado) => {
    if (habilitado.checked) {
      actualizaDatosTabla("montoEfectivo", v_u.totalEntrega);
    } else {
      actualizaDatosTabla("montoEfectivo", 0);
    }
  };

  const habilitadoYape = (habilitado) => {
    if (habilitado.checked) {
      actualizaDatosTabla("montoYape", v_u.totalEntrega);
    } else {
      actualizaDatosTabla("montoYape", 0);
    }
  };

  useEffect(() => {
    console.log(v_u.datosForm);
    // _f_.asignar(ev_u,{d_datosForm_historico: v_u.datosForm})
  }, [v_u.datosForm]);

  return (
    <div className={"MRegistroVentaTiendaCSS-cuerpo"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: false,
            });
            if (v_u.d_exitoRegistrandoVenta) {
              fCerrarComponente?.();
              fActualizarTablaTotal?.(true);
            }
          }}>
          {v_c.preConfirmar_mostrar && (
            <_preconf_.PreConfirmacion
              texto="¿Seguro que desea continuar?"
              fBotonAceptar={() => {
                // console.log({
                //   codUsuario: parametros?.precioVenta,
                //   codPedido: parametros?.codigoPedido,
                //   comentario: parametros?.comentario,
                //   tipo_comprobante: v_u.d_sinComprobante ? 3 : parametros?.codigoComprobante,
                //   pedidooentrega: 2,
                //   tipo_documento: v_u.datosForm.tipoDocumento,
                //   numero_documento: v_u.datosForm.nroDoc,
                //   nombre_cliente: v_u.datosForm.nombre,
                //   montoEfectivo: v_u.datosForm.montoEfectivo,
                //   montoYape: v_u.datosForm.montoYape,
                // });

                const solicitarPedidoAPI = _api_.f_solicitarPedido({
                  parametros: {
                    codUsuario: parametros?.precioVenta,
                    codPedido: parametros?.codigoPedido,
                    comentario: parametros?.comentario,
                    pedidooentrega: 2,
                    tipo_comprobante: v_u.d_sinComprobante ? 3 : parametros?.codigoComprobante,
                    tipo_documento: v_u.datosForm.tipoDocumento,
                    numero_documento: v_u.datosForm.nroDoc,
                    nombre_cliente: v_u.datosForm.nombre,
                    montoEfectivo: v_u.datosForm.montoEfectivo,
                    montoYape: v_u.datosForm.montoYape,
                    fechaEntregaEstimada: "",
                    fechaEntrega: null,
                  },
                  timeout: 5000,
                });

                solicitarPedidoAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  console.log(dPC);
                  if (!dPC.error) {
                    _f_.asignar(ev_c, {
                      procesandoAccion_mostrar: false,
                      modal_titulo: "✅ Éxito",
                      postConfirmar_mostrar: true,
                    });
                    _f_.asignar(ev_u, { d_pdf: dPC.contenido.documento.pdf, d_exitoRegistrandoVenta: true });
                  } else {
                    _f_.asignar(ev_c, {
                      procesandoAccion_mostrar: false,
                      modal_mostrar: false,
                    });
                  }
                });

                _f_.asignar(ev_c, {
                  preConfirmar_mostrar: false,
                  modal_titulo: "⏳ Procesando",
                  procesandoAccion_mostrar: true,
                });
              }}
              fBotonCancelar={() => {
                _f_.asignar(ev_c, { modal_mostrar: false });
              }}
            />
          )}
          {v_c.procesandoAccion_mostrar && <_procAcc_.ProcesandoAccion />}
          {v_c.postConfirmar_mostrar && (
            <_posconf_.PostConfirmacion
              texto={`Se registro la venta en tienda exitosamente.`}
              accion={() => {
                _f_.asignar(ev_c, {
                  modal_estilos: { anchoMI: "30rem", altoMI: "50rem" },
                });
              }}
              fBotonDeAcuerdo={() => {
                fCerrarComponente?.();
                fActualizarTablaTotal?.(true);
              }}>
              <VisorPDF
                id="mi-pdf"
                titulo="PDF"
                base64={v_u.d_pdf}
                nombreArchivo={`${parametros?.tipoComprobante}_${_f_.fechaActual({ formato: "dd_mm_yyyy" })}_${_f_.horaActual({ formato: "hh_mm_ss" })}.pdf`}
                autoDownload={false}
                modoImpresion={esComputadora ? "sistema" : "ventana"}
              />
            </_posconf_.PostConfirmacion>
          )}
        </ModalInformacion>
      )}
      <_form_.Formulario
        form={v_u.form ?? []}
        dext={setactualizaDatosTabla}
        onChangeCampos={{ efectivo: habilitadoEfectivo, yape: habilitadoYape }}
        onBlurCampos={{ nroDoc: datosPersonaApi, tipoDocumento: cambioTipoDocumento }}
        fObtenerDatosFormulario={(datos) => {
          _f_.asignar(ev_u, { datosForm: datos });
        }}></_form_.Formulario>

      <div className={"MRegistroVentaTiendaCSS-opciones"}>
        <_btn_.Boton
          texto={`Sin Comprobante`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_rojo_1)",

            fuente: "1rem",
          }}
          onClick={() => {
            // console.log(v_u.datosForm);
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_estilos: { anchoMI: "30rem", altoMI: "initial" },
              modal_titulo: "❗Confirmar Acción Sin Comprobante",
              preConfirmar_mostrar: true,
            });
            _f_.asignar(ev_u, { d_sinComprobante: true });
          }}
        />
        <_btn_.Boton
          texto={`Emitir Comprobante`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_verde_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_estilos: { anchoMI: "30rem", altoMI: "initial" },
              modal_titulo: "❗Confirmar Acción Para Generar Comprobante",
              preConfirmar_mostrar: true,
            });
            _f_.asignar(ev_u, { d_sinComprobante: false });
          }}
        />
      </div>
    </div>
  );
}
export default MRegistroVentaTienda;
